module.exports = __webpack_public_path__ + "img/background.4ce849e1.png";